import React, {Component} from "react";
import { flowRight as compose } from "lodash";
import NoteForm from "./NoteForm";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { cancelCreateNote } from "../NotesActions";
import { connect } from "react-redux";
import { Map, fromJS, List } from "immutable";
import { validatePresence } from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "title");
  return errors.toJS();
}

class CreateNoteFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      foreignType: this.props.kind,
      foreignId: this.props.kindId,
      status: values.get("status"),
      title: values.get("title"),
      descriptionHtml: values.get("description", ""),
      tags: values.get("tags", List()).toJS()
    }

    return this.props.createNote(updatedValues)
      .then((response) => {
        if (response.data.createNote.errors.length <= 0) {
          this.props.cancelCreateNote(this.props.kind, this.props.kindId);
        } else {
          let errors = createValidationErrors(response.data.createNote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelCreateNote(this.props.kind, this.props.kindId);
  }

  render() {
    let initialValues = fromJS({
      status: "open",
      title: "",
      descriptionHtml: "",
      tags: [],
    });

    return (
      <NoteForm
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const CREATE_NOTE = gql`
  mutation createNote($data: CreateNoteInput!) {
    createNote(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CREATE_NOTE, {
    props: ({ mutate }) => ({
      createNote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelCreateNote})(withMutation(CreateNoteFormContainer));